import React from 'react';

import { RowSkeleton } from './row-skeleton';

interface SearchSkeletonsProps {
	/** Number of skeleton rows to render. Defaults to 5. */
	count?: number;
}

export const SearchSkeletons = ({ count = 5 }: SearchSkeletonsProps): React.JSX.Element => {
	return (
		<>
			{Array.from({ length: count }, (_, index) => (
				<RowSkeleton key={index} />
			))}
		</>
	);
};
